<template>
  <!--<div class="index-homepage" :style="{ height: (contenitoreHeight) + 'px'}" v-if="country !== ''">-->
  <div class="index-homepage" v-if="country !== ''">
    <!--<header-app :counterNuovi="counterNuovi"></header-app>-->
    <div>
      <div class="titolo-app col-lg-14 col-md-11 col-sm-6 col-1 no-padding">
        <span class="titolo-bold hidden-xs">
          {{ $t($route.meta.appName).label }}
        </span>
      </div>

      <div class="contenitore col-24 no-padding" :style="{ height: (contenitoreHeight - 40) + 'px' }">
        <div class="title col-24">
          <span>{{ getDate() }}</span>
        </div>

        <!-- HEADER FRANCIA -->
        <div class="row row-custom testata" v-if="country === '2'">
          <div class="card-testata col-lg-6 col-md-12 col-24">
            <dashboard-card-doppia :properties="utente"></dashboard-card-doppia>
          </div>
          <div class="card-testata col-lg-6 col-md-12 col-24">
            <dashboard-card-doppia :properties="recapiti"></dashboard-card-doppia>
          </div>
          <div class="card-testata col-lg-6 col-md-12 col-24">
            <dashboard-card :properties="lastAccess"></dashboard-card>
          </div>
          <div class="card-testata col-lg-6 col-md-12 col-24">
            <dashboard-card :properties="manuale_utente"></dashboard-card>
          </div>
        </div>
        <!-- HEADER ITALIA, SPAGNA, BELGIO e GERMANIA -->
        <div class="row row-custom testata"
          v-if="country === '1' || country === '3' || country === '4' || country === '5'">
          <div class="card-testata col-lg-6 col-md-12 col-24">
            <dashboard-card-doppia :properties="utente"></dashboard-card-doppia>
          </div>
          <div class="card-testata col-lg-6 col-md-12 col-24">
            <dashboard-card :properties="societa"></dashboard-card>
          </div>
          <div class="card-testata col-lg-6 col-md-12 col-24">
            <dashboard-card-doppia :properties="recapiti"></dashboard-card-doppia>
          </div>
          <div class="card-testata col-lg-6 col-md-12 col-24">
            <dashboard-card :properties="lastAccess"></dashboard-card>
          </div>
        </div>
        <!-- ITALIA, FRANCIA, SPAGNA, BELGIO E GERMANIA-->
        <div class="row row-custom centrale">
          <div class="mid-left col-lg-6 col-md-6 col-24 " v-loading="loadingFerie">
            <prospetto-assenze style="margin-bottom: 10px;" :codLang="codLang"></prospetto-assenze>
            <!--<prospetto-assenze1 v-if="country === '1'" contenitoreHeight="320"></prospetto-assenze1>
            <prospetto-assenze4 v-if="country === '4'" contenitoreHeight="320"></prospetto-assenze4>
            <prospetto-assenze5 v-if="country === '5'" contenitoreHeight="355"style="margin-bottom: 10px"></prospetto-assenze5>
            <prospetto-assenze2 v-if="country === '2'" contenitoreHeight="320"
              style="margin-bottom: 10px"></prospetto-assenze2>
            <prospetto-assenze3 v-if="country === '3'" contenitoreHeight="355"></prospetto-assenze3>-->
            <comunicazione :properties="avvisi"
              :contenitoreHeight="(contenitoreHeight - 40 - 60 - 130 - (country === '5' | country === '3' ? 355 : 320) - 20)"
              :loading="loading" :messaggi="dsh_ANN" style="margin-bottom: 10px"></comunicazione>
          </div>
          <div class="mid-right col-lg-6 col-md-6 col-24">
            <carousel-pictures :contenitoreHeight="contenitoreHeight - 40 - 60 - 130 - 10" :loadingImg="loading"
              :images="dsh_CAI"></carousel-pictures>
          </div>
          <div class="mid-right col-lg-6 col-md-6 col-24">
            <content-manager
              v-if="country === '1' || country === '2' || country === '3' || country === '4' || country === '5'"
              :properties="cmUltimoMese" :contenitoreHeight="320"></content-manager>
            <carousel-video :contenitoreHeight="280" :loadingImg="loading" :images="dsh_CAV"></carousel-video>
          </div>
          <div class="mid-right col-lg-6 col-md-6 col-24">
            <comunicazione :properties="comUltimoMese" :contenitoreHeight="contenitoreHeight - 40 - 60 - 130 - 10"
              :loading="loading" :messaggi="dsh_ULT"></comunicazione>
          </div>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import moment from 'moment'
import DashboardCardDoppia from '../ServiceComponents/DashboardCardDoppia.vue'
import DashboardCard from '../ServiceComponents/DashboardCard.vue'
import { bus } from '../Bus.js'
import Youtube from './Youtube.vue'
import CarouselPictures from './CarouselPictures'
import CarouselVideo from './CarouselVideo'
import Comunicazione from './Comunicazione.vue'
import ContentManager from './ContentManager.vue'
/*import ProspettoAssenze1 from './ProspettoAssenze1.vue'
import ProspettoAssenze2 from './ProspettoAssenze2.vue'
import ProspettoAssenze3 from './ProspettoAssenze3.vue'
import ProspettoAssenze4 from './ProspettoAssenze4.vue'
import ProspettoAssenze5 from './ProspettoAssenze5.vue'*/
import ProspettoAssenze from './ProspettoAssenze.vue'

export default {
  components: {
    DashboardCard,
    DashboardCardDoppia,
    Youtube,
    CarouselPictures,
    CarouselVideo,
    Comunicazione,
    ContentManager,
    /*ProspettoAssenze1,
    ProspettoAssenze2,
    ProspettoAssenze3,
    ProspettoAssenze4,
    ProspettoAssenze5,*/
    ProspettoAssenze
  },
  props: {
    area: {
      type: String,
      default: 'documenti'
    },
    contenitoreHeight: {
      type: Number
    }
  },
  name: 'DashBoard',
  i18n: {
    messages: {
      it_IT: {
        dashboard: {
          days: {
            0: 'Domenica',
            1: 'Lunedì',
            2: 'Martedì',
            3: 'Mercoledì',
            4: 'Giovedì',
            5: 'Venerdì',
            6: 'Sabato'
          },
          user: 'Nome Utente',
          soc: 'Società',
          lastAccess: 'Ultimo Accesso',
          recapiti: 'Recapiti',
          cards_ferie: {
            des_0: 'Ferie Residue',
            des_1: 'Ferie Richieste',
            des_2: 'Roll Residuo',
            des_3: 'Roll Richiesto',
            d: 'Giorni',
            h: 'Ore'
          },
          timb: 'Timbrature',
          entrata: 'Entrata',
          uscita: 'Uscita',
          manuali: {
            titolo: 'Manuali',
            utente_v1: 'Manuale Utente',
            utente_v2: 'Revisione Aprile 2021'
          },
          comunicazioni: {
            titoloAvvisi: 'Avvisi',
            titoloCom: 'Comunicazioni ultimo mese'
          },
          contentManager: {
            titoloUtimoMese: 'Ultimo Mese'
          },
          msg: {},
          btn: {}
        }
      },
      fr_FR: {
        dashboard: {
          days: {
            0: 'Dimanche',
            1: 'Lundi',
            2: 'Mardi',
            3: 'Mercredi',
            4: 'Jeudi',
            5: 'Vendredi',
            6: 'Samedi'
          },
          user: 'Identifiant',
          soc: 'Société',
          lastAccess: 'Dernier accès',
          recapiti: 'Contacts',
          cards_ferie: {
            des_0: 'Congé Résiduelles',
            des_1: 'Congé Requises',
            des_2: 'RCR Résiduelles',
            des_3: 'RCR Requises',
            d: 'Jours',
            h: 'Heure'
          },
          timb: 'Timbrature',
          entrata: 'Entrée',
          uscita: 'Sortie',
          manuali: {
            titolo: 'Manuels',
            utente_v1: 'Portail Employes.',
            utente_v2: 'Révision Avril 2021'
          },
          comunicazioni: {
            titoloAvvisi: 'Annonces',
            titoloCom: 'Communications'
          },
          contentManager: {
            titoloUtimoMese: 'Documents Paie du Mois'
          },
          msg: {},
          btn: {}
        }
      },
      es_ES: {
        dashboard: {
          days: {
            0: 'Domingo',
            1: 'Lunes',
            2: 'Martes',
            3: 'Miércoles',
            4: 'Jueves',
            5: 'Viernes',
            6: 'Sábado'
          },
          user: 'Personal',
          soc: 'Empresa',
          lastAccess: 'Último acceso',
          recapiti: 'Contactos',
          cards_ferie: {
            des_0: 'Congé Résiduelles',
            des_1: 'Congé Requises',
            des_2: 'RCR Résiduelles',
            des_3: 'RCR Requises',
            d: 'Jours',
            h: 'Heure'
          },
          timb: 'Timbrature',
          entrata: 'Entrée',
          uscita: 'Sortie',
          manuali: {
            titolo: 'Manuales',
            utente_v1: 'Portal de Trabajador.',
            utente_v2: 'Revisado Abril 2021'
          },
          comunicazioni: {
            titoloAvvisi: 'Anuncios',
            titoloCom: 'Comunicaciones Mes Actual'
          },
          contentManager: {
            titoloUtimoMese: 'Mes Actual'
          },
          msg: {},
          btn: {}
        }
      },
      de_DE: {
        dashboard: {
          days: {
            0: 'Sonntag',
            1: 'Montag',
            2: 'Dienstag',
            3: 'Mittwoch',
            4: 'Donnerstag',
            5: 'Freitag',
            6: 'Samstag'
          },
          user: 'Benutzername',
          soc: 'Firma',
          lastAccess: 'Letzter Zugriff',
          recapiti: 'Kontaktdaten',
          cards_ferie: {
            des_0: 'Ferie Residue',
            des_1: 'Ferie Richieste',
            des_2: 'Roll Residuo',
            des_3: 'Roll Richiesto',
            d: 'Giorni',
            h: 'Ore'
          },
          timb: 'Timbrature',
          entrata: 'Entrata',
          uscita: 'Uscita',
          manuali: {
            titolo: 'Anleitungen',
            utente_v1: 'Benutzerhandbuch',
            utente_v2: 'Revision April 2021'
          },
          comunicazioni: {
            titoloAvvisi: 'Anzeigen',
            titoloCom: 'Kommunikation im letzten Monat'
          },
          contentManager: {
            titoloUtimoMese: 'Dokumente im letzten Monat' //'Letzten Monat'
          },
          msg: {},
          btn: {}
        }
      },
      en_GB: {
        dashboard: {}
      }
    }
  },
  data() {
    return {
      codLang: '',
      loading: false,
      showScroll: true,
      menuApps: [],
      menu: {},
      apps: [],
      areaProva: this.area,
      country: '',
      loadingFerie: false,
      utente: {
        bgColorUp: 'linear-gradient(to right, rgb(0, 99, 92), rgb(2, 177, 166))',
        bgColorDown: '#49aca6',
        iconColorUp: '#fff',
        iconColorDown: '',
        titleUp: '',
        titleDown: '',
        iconaUp: 'riv-user2',
        iconaDown: '',
        typeUp: 'Info',
        typeDown: 'Title',
        value1Up: '',
        value2Up: '',
        valueDown: ''
      },
      societa: {
        bgColor: 'linear-gradient(to right, rgb(62, 24, 68), rgb(175, 85, 168))',
        iconColor: '#fff',
        title: '',
        icona: '',
        type: 'Info',
        value1Up: '',
        value2Up: ''
      },
      manuale_utente: {
        /*bgColor: '#fff',
        borderColor: '#e7e7e7',
        iconColor: '#d20b07',
        iconPosition: 'right',
        color: '#585c60',
        title: '',
        icona: 'riv-pdf_RGB',
        type: 'manual',
        value1Up: '',
        value2Up: '',*/
        bgColor: 'linear-gradient(to right, rgb(62, 24, 68), rgb(175, 85, 168))',
        iconColor: '#fff',
        title: '',
        icona: 'riv-pdfMan',
        type: 'manual',
        value1Up: '',
        value2Up: '',
        url: './static/docs/Guide Portail RH LUCI VAP 29042021.pdf'
      },
      lastAccess: {
        bgColor: 'linear-gradient(to right, rgb(17, 24, 88), rgb(36, 47, 150))',
        iconColor: '#fff',
        title: '',
        icona: 'riv-calendar3',
        type: 'Info',
        value1Up: '',
        value2Up: ''
      },
      recapiti: {
        bgColorUp: 'linear-gradient(to right, rgb(172, 35, 127), rgb(187, 98, 159))',
        bgColorDown: 'rgb(187, 98, 159)',
        iconColorUp: '',
        iconColorDown: '#fff',
        titleUp: '',
        titleDown: '',
        iconaUp: '',
        iconaDown: 'riv-phone2',
        typeUp: '',
        typeDown: '',
        value1Up: '',
        value2Up: '',
        valueDown: ''
      },
      avvisi: {
        compressa: false,
        bgColor: '#fff',
        border: '1px solid #e7e7e7',
        borderRadius: '4px',
        icona: '',
        iconColor: '',
        title: '',
        type: 'ANN',
      },
      comUltimoMese: {
        compressa: true,
        bgColor: '#fff',
        border: '1px solid #e7e7e7',
        borderRadius: '4px',
        icona: 'riv-voice',
        iconColor: '#e7e7e7',
        title: '',
        type: 'ULT',
      },
      cmUltimoMese: {
        compressa: true,
        bgColor: '#fff',
        border: 'none',
        borderRadius: '4px',
        icona: 'riv-cal10',
        iconColor: '#e7e7e7',
        title: '',
        url: 'ultMese',
        numSchede: '6'
      },
      cards_ferie: [],
      // servizio dashboard
      dsh_CAV: [],
      dsh_CAI: [],
      dsh_ANN: [],
      dsh_ULT: [],
      dsh_INF: []
    }
  },
  watch: {
    '$route.meta.appName': function (to, from) {
      if (!this._inactive)
        this.initialize()
    },
    '$store.state.mail': function (to, from) {
      this.$set(this.recapiti, 'valueUp', this.$store.state.mail)
    }
  },
  mounted: function () {
    this.country = this.$store.state.country
  },
  activated: function () {
    this.country = this.$store.state.country
    this.initialize()
  },
  deactivated: function () {
  },
  methods: {
    initialize: function () {
      this.codLang = sessionStorage.getItem('codLang')
      let lastAccess = this.$store.state.lastAccess
      if (lastAccess !== '' && lastAccess !== undefined) {
        this.$set(this.lastAccess, 'value1Up', lastAccess.substr(6, 2) + '/' + lastAccess.substr(4, 2) + '/' + lastAccess.substr(0, 4))
        this.$set(this.lastAccess, 'value2Up', lastAccess.substr(8, 2) + ':' + lastAccess.substr(10, 2))
      }
      this.getInfo()
      this.getMessaggi()
      //this.getRiepilogoFerie()
      this.$nextTick(() => {
        this.utente.titleDown = this.$t('dashboard.user')
        this.societa.title = this.$t('dashboard.soc')
        this.lastAccess.title = this.$t('dashboard.lastAccess')
        this.recapiti.titleUp = this.$t('dashboard.recapiti')
        this.manuale_utente.title = this.$t('dashboard.manuali.titolo')
        this.manuale_utente.value1Up = this.$t('dashboard.manuali.utente_v1')
        this.manuale_utente.value2Up = this.$t('dashboard.manuali.utente_v2')
        this.avvisi.title = this.$t('dashboard.comunicazioni.titoloAvvisi')
        this.comUltimoMese.title = this.$t('dashboard.comunicazioni.titoloCom')
        this.cmUltimoMese.title = this.$t('dashboard.contentManager.titoloUtimoMese')
        bus.$off('changeLanguage')
        bus.$on('changeLanguage', () => {
          this.codLang = sessionStorage.getItem('codLang')
          this.$nextTick(() => {
            this.utente.titleDown = this.$t('dashboard.user')
            this.societa.title = this.$t('dashboard.soc')
            this.lastAccess.titleUp = this.$t('dashboard.lastAccess')
            this.recapiti.title = this.$t('dashboard.recapiti')
            this.manuale_utente.title = this.$t('dashboard.manuali.titolo')
            this.manuale_utente.value1Up = this.$t('dashboard.manuali.utente_v1')
            this.manuale_utente.value2Up = this.$t('dashboard.manuali.utente_v2')
            this.avvisi.title = this.$t('dashboard.comunicazioni.titoloAvvisi')
            this.comUltimoMese.title = this.$t('dashboard.comunicazioni.titoloCom')
            this.cmUltimoMese.title = this.$t('dashboard.contentManager.titoloUtimoMese')
          })
        })
      })
    },
    getDate: function () {
      let date = moment()
      return this.$i18n.t('dashboard.days.' + date.day()) + ' ' + date.format('D') + ' ' + this.$i18n.t('el.datepicker.month' + date.format('M')) + ' ' + date.format('YYYY')
    },
    getInfo: function () {
      this.$set(this.utente, 'value1Up', this.$store.state.nomex)
      this.$set(this.utente, 'value2Up', this.$store.state.cognx)
      this.$set(this.utente, 'valueDown', this.$store.state.user)
      this.$set(this.societa, 'value1Up', this.$store.state.localita)
      this.$set(this.societa, 'value2Up', this.$store.state.desSoc)
      this.$set(this.recapiti, 'valueUp', this.$store.state.mail)
      this.$set(this.recapiti, 'valueDown', this.$store.state.tel1)
    },
    getMessaggi: function () {
      this.$set(this, 'dsh_CAV', [])
      this.$set(this, 'dsh_CAI', [])
      this.$set(this, 'dsh_ANN', [])
      this.$set(this, 'dsh_ULT', [])
      this.$set(this, 'dsh_INF', [])
      this.loading = true
      let obj = {
        params: {
          tipo: 'CAI,CAV,ANN,ULT,INF'
        }
      }
      this.$http.get('dashboard/' + this.country + '/messaggi', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'dsh_CAV', response.body.data.CAV === undefined ? [] : response.body.data.CAV)
            this.$set(this, 'dsh_CAI', response.body.data.CAI === undefined ? [] : response.body.data.CAI)
            this.$set(this, 'dsh_ANN', response.body.data.ANN === undefined ? [] : response.body.data.ANN)
            this.$set(this, 'dsh_ULT', response.body.data.ULT === undefined ? [] : response.body.data.ULT)
            this.$set(this, 'dsh_INF', response.body.data.INF === undefined ? [] : response.body.data.INF)
            bus.$emit("load_dsh_INF", this.dsh_INF)
          }
          this.loading = false
        })
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.index-homepage {
  height: 100%;

  .titolo-app {
    padding-left: 5px;
    .set-font(@size: 15px; @color: @greenRiva);
    text-transform: uppercase;
    letter-spacing: 2px;
    overflow: hidden;
    height: 50px;
    line-height: 50px;

    .titolo-bold {
      font-weight: 700;
    }
  }

  .title {
    height: 60px;
    line-height: 60px;
    position: relative;
    cursor: pointer;
    padding-top: 15px;
    padding-bottom: 15px;
    display: block;
    text-align: center;
    letter-spacing: 3px;
    text-transform: uppercase;
    .set-font(@size: 16px, @color: @oroRiva, @weight: bold, @family: 'os-regular');
    //height: 50px;
    //padding-top: 15px;
    padding: 0;
    padding-right: 10px;
    // padding-top: 10px;
    // padding-bottom: 10px;
  }

  .testata {
    min-height: 130px;

    .card-testata {
      margin-bottom: 10px;
    }
  }

  .mid-central {
    .box {
      // height: 100%;
      overflow: auto;
      border: 1px solid #e7e7e7;
      border-radius: 4px;
      -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
      box-shadow: 0px 0px 13px 1px #e7e7e7;
      padding: 10px;
    }

    .pictures {
      img {
        width: 100%;
      }
    }
  }

  .card-timb {
    height: 100%;
    width: 100%;
    display: inline-block;
    margin-bottom: 6px;
    background: url("/static/img/time-left.svg") no-repeat left;
    background-position-y: 150px;
    background-position-x: -15px;
    background-size: 100px 100px;
    //min-height: 44px;
    background-color: white;

    .scheda {
      width: 100%;
      height: 226px;
      margin-bottom: 6px;
      border: 1px solid #e7e7e7;
      border-radius: 4px;
      // -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
      // -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
      // box-shadow: 0px 0px 13px 1px #e7e7e7;
      margin: auto;
      text-align: center;

      .scheda-label {
        margin-top: 8px;
        text-transform: uppercase;
        height: 30px;
        line-height: 16px;
        .set-font(@size: 14px; @color: #48adb5);
        text-align: left;
        padding-left: 15px;
      }

      .scheda-int {
        line-height: 40px;
        height: 40px;
        margin-left: 20px;
        margin-right: 20px;
        border-bottom: 1px solid #bd3090;
        .set-font(@size: 14px; @color: #bd3090; @family: 'os-semibolditalic');
      }

      .scheda-body {
        margin-left: 20px;
        margin-right: 20px;
        height: 100px;

        span {
          display: block;
          margin-top: 10px;
          margin-bottom: 10px;
          .set-font(@size: 16px; @color: #3f2a6d);
          line-height: 30px;
        }
      }

      /*.scheda-label {
          .set-font(@size: 12px; @color: #bd3090);
        }*/
      .scheda-tipo {
        margin-top: 10px;
        text-transform: uppercase;
        .set-font(@size: 12px; @color: #3f2a6d);
      }
    }
  }

  /*.mid-left {
      height: 232px;
      .card-ferie {
        height: 48%;
        width: 50%;
        display: inline-block;
        margin-bottom: 6px;
        .scheda {
          border: 1px solid #e7e7e7;
          border-radius: 4px;
          // -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
          // -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
          // box-shadow: 0px 0px 13px 1px #e7e7e7;
          width: 96%;
          margin: auto;
          height: 110px;
          text-align: center;
          .scheda-label {
            margin-top: 8px;
            text-transform: uppercase;
            height: 24px;
            line-height: 16px;
            .set-font(@size: 14px; @color: #bd3090);
          }
          .scheda-valore {
            margin-top: 6px;
            .set-font(@size: 33px; @color: #48adb5);
            line-height: 30px;
          }
          .scheda-tipo {
            margin-top: 10px;
            text-transform: uppercase;
            .set-font(@size: 12px; @color: #3f2a6d);
          }
        }
      }
    }*/
}
</style>



// WEBPACK FOOTER //
// src/components/HomePage/DashBoard.vue